import { List, Paragraph } from '@zillow/constellation';
import type { ComponentType } from 'react';

import { TextStyledComponent } from '../TextStyledComponent';
import type { TextStyledComponentProps } from '../../model/TextStyledComponent';

import { StyledListItem } from './StyledComponents';

const bodyTypeMap = {
  paragraph: Paragraph,
  unorderedList: List,
  orderedList: List,
  bareboneList: List,
} as const;

const listTypeMap = {
  unorderedList: '',
  orderedList: 'number',
  bareboneList: 'none',
} as const;

type Props = {
  sentences: Array<Array<TextStyledComponentProps>>;
  type: keyof typeof bodyTypeMap | string;
  csEventsHandler?: ({ text }: { text: string }) => void;
  csEventsIdMap?: Record<string, string>;
};

type ComponentProps = React.ComponentProps<typeof Paragraph> | React.ComponentProps<typeof List>;

export const BodyStyledComponent = ({ sentences, type, csEventsHandler, csEventsIdMap }: Props) => {
  const DynamicBodyComponent: ComponentType<ComponentProps> = bodyTypeMap[type as keyof typeof bodyTypeMap];
  const listProps = listTypeMap[type as keyof typeof listTypeMap]
    ? { appearance: listTypeMap[type as keyof typeof listTypeMap] }
    : false;
  const DynamicListItemComponent = listTypeMap[type as keyof typeof listTypeMap] !== undefined ? StyledListItem : null;

  return (
    <DynamicBodyComponent {...listProps}>
      {sentences.map((sentence, i) => {
        if (DynamicListItemComponent !== null) {
          return (
            <DynamicListItemComponent key={i}>
              {sentence.map((textComponent, i) => {
                return <TextStyledComponent key={i} styledComponentContent={textComponent} />;
              })}
            </DynamicListItemComponent>
          );
        } else {
          return sentence.map((textComponent, i) => {
            return (
              <TextStyledComponent
                key={i}
                styledComponentContent={textComponent}
                csEventsHandler={csEventsHandler}
                csEventsIdMap={csEventsIdMap}
              />
            );
          });
        }
      })}
    </DynamicBodyComponent>
  );
};
